(function () {
  function findSubscriptionOption(productInfo) {
    var subscribeText = productInfo.querySelector('.appstle_subscribe_save_text');
    if (!subscribeText) return null;

    return (
      subscribeText.closest('.appstle_subscription_wrapper_option') ||
      subscribeText.closest('.appstle_radio_label')
    );
  }

  function placeSubscriptionBonus(panel, productInfo) {
    var subscriptionOption = findSubscriptionOption(productInfo);
    if (!subscriptionOption) return;

    if (subscriptionOption.nextElementSibling !== panel) {
      subscriptionOption.insertAdjacentElement('afterend', panel);
    }
  }

  function initSubscriptionBonus(panel) {
    if (panel.dataset.subscriptionBonusInitialized === 'true') return;

    var productInfo = panel.closest('.product__info-container');
    if (!productInfo) return;

    panel.dataset.subscriptionBonusInitialized = 'true';
    placeSubscriptionBonus(panel, productInfo);

    var placementQueued = false;
    var observer = new MutationObserver(function () {
      if (placementQueued) return;

      placementQueued = true;
      requestAnimationFrame(function () {
        placementQueued = false;
        placeSubscriptionBonus(panel, productInfo);
      });
    });

    observer.observe(productInfo, {
      childList: true,
      subtree: true
    });
  }

  function initSubscriptionBonuses(root) {
    root.querySelectorAll('.subscription-bonus').forEach(initSubscriptionBonus);
  }

  function init() {
    initSubscriptionBonuses(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSubscriptionBonuses(event.target);
  });
})();
